import { Res } from 'api/api.types';
import { axiosInstance } from 'api/axios';

export const getRequestsForOffersCount = async () =>
  await axiosInstance.get<Res<number>>('/requestForOffer/count');
